import React from "react";
import { Upload, Tooltip, Button, Input, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormItem } from "Components/form";
import { Controller } from "react-hook-form";

const delay = require("lodash/delay");

export default function DocumentUploader({
  form,
  fieldArray,
  multiple = true,
  ...props
}) {
  const { fields: files, append, remove } = fieldArray;
  const { errors } = form;

  const fileUploadProps = {
    beforeUpload: (file) => {
      if (file.size && Math.ceil(file.size / (1024 * 1024)) > 40) {
        message.warning(
          `${file.name} adlı Dokümanın boyutu 1 MB'dan fazla olduğu için eklenemedi.`
        );
        return false;
      }

      delay(
        function (file) {
          append({ documentName: file.name, file: file });
        },
        500,
        file
      );

      return false;
    },
  };

  return (
    <>
      <div className="uploader-wrapper">
        <Upload.Dragger
          multiple={multiple}
          showUploadList={false}
          {...fileUploadProps}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FontAwesomeIcon
            icon={["fas", "upload"]}
            size="3x"
            style={{ margin: 16 }}
          />
          <p>
            Eklemek istediğiniz dosyaları buraya sürekleyerek
            <br />
            ya da tıklayarak seçebilirsiniz
          </p>
        </Upload.Dragger>
      </div>
      {files.map((item, index) => {
        return (
          <FormItem
            key={item.key}
            htmlFor={`files[${index}].documentName`}
            error={
              errors.files &&
              errors.files.length > index &&
              errors.files[index] &&
              errors.files[index].documentName
            }
            style={{ marginBottom: 8, width: "100%" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
              }}
            >
              <Tooltip title={files[index].file.name}>
                <FontAwesomeIcon
                  icon={["fas", "paperclip"]}
                  style={{ marginRight: 8 }}
                />
              </Tooltip>
              <Controller
                control={form.control}
                name={`files[${index}].documentName`}
                defaultValue={item.documentName}
                as={
                  <Input
                    style={{ width: "100%" }}
                    defaultValue={`${item.documentName}`}
                    size="small"
                    onFocus={(e) => e.target.select()}
                    placeholder="Doküman Adı giriniz giriniz"
                  />
                }
              />
              <Button
                type="link"
                style={{ color: "red" }}
                onClick={() => {
                  remove(index);
                }}
              >
                <FontAwesomeIcon icon={["far", "trash-alt"]} />
              </Button>
            </div>
          </FormItem>
        );
      })}
    </>
  );
}
